import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTabsStore } from '@/stores/tabs.store'

// Masaüstü (Tauri): modül kısayolları sekme açar; web: klasik navigate.
const isTauri = typeof window !== 'undefined' && !!(window as { __TAURI__?: unknown }).__TAURI__

/**
 * Global keyboard shortcuts for iNova.
 *
 * Shortcuts:
 *  Ctrl+1 → Dashboard        Ctrl+2 → Stok       Ctrl+3 → Cari
 *  Ctrl+4 → Fatura            Ctrl+5 → Kasa       Ctrl+6 → Banka
 *  F12    → POS (tam ekran)
 *  Ctrl+N → Yeni kayıt (genel, her modül kendi handler'ını overrides edebilir)
 *  Alt+F4 → (tarayıcıya bırak)
 */
export function useGlobalKeyboardShortcuts() {
  const navigate = useNavigate()

  useEffect(() => {
    // Masaüstünde modül kısayolu sekme açar; web'de mevcut navigate davranışı.
    const go = (path: string, title: string) => {
      if (isTauri) useTabsStore.getState().openTab(path, title)
      else navigate(path)
    }

    const handler = (e: KeyboardEvent) => {
      // F12 → POS (her iki modda tam ekran, sekme dışı)
      if (e.key === 'F12') {
        e.preventDefault()
        navigate('/pos')
        return
      }

      if (!e.ctrlKey && !e.metaKey) return

      switch (e.key) {
        case '1':
          e.preventDefault()
          if (isTauri) go('/dashboard', 'Ana Sayfa')
          else navigate('/')
          break
        case '2':
          e.preventDefault()
          go('/stok', 'Stok')
          break
        case '3':
          e.preventDefault()
          go('/cari', 'Cari Hesap')
          break
        case '4':
          e.preventDefault()
          go('/fatura', 'Fatura')
          break
        case '5':
          e.preventDefault()
          go('/kasa', 'Kasa')
          break
        case '6':
          e.preventDefault()
          go('/banka', 'Banka')
          break
      }
    }

    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [navigate])
}

/**
 * Page-level shortcut: Ctrl+N → create new record
 */
export function useNewRecordShortcut(onNew: () => void) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'n') {
        // Don't trigger when an input/textarea is focused
        const tag = (e.target as HTMLElement).tagName
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return
        e.preventDefault()
        onNew()
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onNew])
}

/**
 * Ctrl+S → save in form pages
 */
export function useSaveShortcut(onSave: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return
    const handler = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        e.preventDefault()
        onSave()
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onSave, enabled])
}
